import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { SparklesIcon } from 'lucide-react';
import { Button } from './Button';
export function Navbar() {
  const navigate = useNavigate();
  return <header className="sticky top-0 z-50 w-full" data-id="element-94">
      {/* Promo Banner */}
      <div className="bg-gold text-navy" data-id="element-95">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-2 flex items-center justify-center gap-1.5 sm:gap-2 text-center text-xs sm:text-sm font-semibold" data-id="element-96">
          <SparklesIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 flex-shrink-0" data-id="element-97" />
          <span className="truncate sm:whitespace-normal" data-id="element-98">
            <span className="sm:hidden" data-id="element-99">
              Summer Special: $400–$700 Apt Moves
            </span>
            <span className="hidden sm:inline" data-id="element-100">
              Summer Special: Apartment Moves $400–$700. Fast, Free Quotes.
            </span>
          </span>
          <SparklesIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 flex-shrink-0 hidden sm:inline" data-id="element-101" />
        </div>
      </div>

      <nav className="w-full bg-white border-b border-gray-100 shadow-sm" data-id="element-102">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
          <div className="flex justify-between items-center h-16 sm:h-20 gap-3" data-id="element-104">
            <Link to="/" className="flex-shrink min-w-0 flex items-center" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/nRTWyz1hEwVbTBgmEWT7Fq/Untitled_design_(2)-Photoroom.png" alt="Justice Moving Co. Logo" className="h-12 sm:h-16 w-auto object-contain" data-id="element-106" />
            </Link>

            <div className="flex-shrink-0" data-id="element-107">
              <Button onClick={() => navigate('/quote')} variant="primary" className="text-sm sm:text-base px-3 sm:px-6 py-2 sm:py-3" data-id="element-108">
                <span className="sm:hidden" data-id="element-109">Free Quote</span>
                <span className="hidden sm:inline" data-id="element-110">Get a Free Quote</span>
              </Button>
            </div>
          </div>
        </div>
      </nav>
    </header>;
}